import React from "react";
import { InlineTextField } from "~/components/inline-text-field";
import { InlineProgress } from "~/components/inline-progress";
import { randomizeName } from "~/components/autofill-disabled-input";

export type InlineTextDisplayProps = {
  errorMessage: string;
  name: string;
  suggestionText: string;
  selectedText: string | null;
  onSuggestionTextChanged: React.Dispatch<string>;
  onFocus?: React.Dispatch<React.FocusEvent<HTMLInputElement>>;
  onBlur?: React.Dispatch<React.FocusEvent<HTMLInputElement>>;
  onKeyDown?: React.Dispatch<React.KeyboardEvent>;
  loading?: boolean;
  disabled?: boolean;
  required?: boolean;
};

export const InlineTextDisplay: React.FC<InlineTextDisplayProps> = (props) => {
  const {
    suggestionText,
    onSuggestionTextChanged,
    errorMessage,
    name,
    selectedText,
    onKeyDown,
    onFocus,
    onBlur,
    loading,
    disabled,
    required,
  } = props;

  const isSelected = selectedText != null;
  const computedSuggestionText = isSelected ? selectedText : suggestionText;

  const focusHandler = onFocus;

  const randomizedName = randomizeName(name);

  return (
    <section className={"inline-text-display"}>
      <InlineTextField
        value={computedSuggestionText}
        onChange={(evt: React.ChangeEvent<HTMLInputElement>) =>
          onSuggestionTextChanged(evt.target.value)
        }
        onFocus={focusHandler}
        onBlur={onBlur}
        onKeyDown={onKeyDown}
        name={randomizedName}
        autoComplete="new-password"
        disabled={disabled}
        errorMessage={errorMessage}
        required={required}
      />
      {loading && <InlineProgress />}
    </section>
  );
};
